import _ from 'lodash'
import { ASharedModal, SharedModalTitle } from 'views/components/SharedModal'
import { AddFields, ShipLoadCommonContent } from './ModalCommonContent'
import { useFormik } from 'formik'
import { useAFormHandler } from 'analytics/hooks'
import { apiClient } from 'modules/utils/httpClient'
import { refetchFunc } from 'modules/domain/common/hooks'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { endpoints } from 'modules/endpoints'
import { ShipLoadWorkTypes } from 'modules/domain/deal/types'

type Props = {
  onClose: () => void
  refetch: refetchFunc
  dealId: string
}

export const AddShipLoadModal: FC<Props> = ({ onClose, refetch, dealId }) => {
  const { t } = useTranslation('deal')

  const { formProgress, formHandler } = useAFormHandler()

  const formik = useFormik<AddFields>({
    initialValues: {
      regional: '',
      work_type: [ShipLoadWorkTypes.sample, ShipLoadWorkTypes.ship_loading, ShipLoadWorkTypes.unloading],
      load_date: null,
      quantity: null,
      record_type: 'export',
    },

    onSubmit: formHandler(
      () => {
        const restData = _.omit(formik.values, 'work_type')
        const data = formik.values.work_type.map((work_type) => ({
          work_type,
          ...restData,
        }))
        return Promise.all(data.map((workData) => apiClient.post(endpoints.dealShipLoading(dealId), workData)))
      },
      {
        onSuccess: async () => {
          await refetch(true)
          onClose()
        },
        onError: (error) => {
          const { errors } = error
          formik.setErrors(errors)
        },
      },
    ),
  })

  return (
    <ASharedModal id="shipLoading" onClose={onClose}>
      <SharedModalTitle>{t('accordion.loading.add_ship_load')}</SharedModalTitle>
      <ShipLoadCommonContent formik={formik} onClose={onClose} progress={formProgress} />
    </ASharedModal>
  )
}
